import CommonWebinarRegistrationDate from 'common/components/entities/WebinarRegistrationDate/WebinarRegistrationDate'
import WebinarRegistrationDateInterface from 'common/types/entities/WebinarRegistrationDateInterface'
import { changeField } from 'publisher/actions/optInActions'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import React from 'react'
import { useDispatch } from 'react-redux'
import FieldErrors from '../../../components/FieldErrors'
import {
  optInSelectors,
  pageSelectors,
  useOptIn,
  usePage,
} from '../../../store'

type WebinarRegistrationDateProps = {
  entity: WebinarRegistrationDateInterface
}

function WebinarRegistrationDate({ entity }: WebinarRegistrationDateProps) {
  const dispatch = useDispatch()
  const locale = usePage(pageSelectors.getLocale)
  const errors = useOptIn(optIn =>
    optInSelectors.getFieldErrors(optIn, 'datetime'),
  )
  const time = useOptIn(optIn =>
    optInSelectors.getFieldValue(optIn, 'datetime'),
  )

  function handleChangeField(value: string | number) {
    dispatch(changeField('datetime', value))
  }

  return (
    <StyleWrapper
      appearance={entity.appearance}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <CommonWebinarRegistrationDate
        attrId={entity.htmlAttrId}
        interval={entity.interval}
        spaceBetween={entity.spaceBetween}
        scheduledHours={entity.scheduledHours}
        timeFormat={entity.timeFormat}
        changeTime={handleChangeField}
        locale={locale}
        time={time}
      />
      <FieldErrors errors={errors} />
    </StyleWrapper>
  )
}

export default WebinarRegistrationDate
